import { render, staticRenderFns } from "./homework-list.vue?vue&type=template&id=35a345ea&"
import script from "./homework-list.vue?vue&type=script&lang=js&"
export * from "./homework-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports